import { FC } from 'react'

import Page from '@/client/submodules/Page'
import { Featured } from './Featured'
import { LabelGalleryProps } from './types'
import dynamic from 'next/dynamic'
import { Gallery } from './Gallery'

export const LabelGallery: FC<LabelGalleryProps> = ({
  seo,
  header,
  footer,
  content: { breadcrumb, title, subtitle, gallery, filter_text_for_all_photos }
}) => (
  <Page seo={seo} header={header} footer={footer}>
    <Featured breadcrumb={breadcrumb} title={title} subtitle={subtitle} />
    <Gallery gallery={gallery} filter_text_for_all_photos={filter_text_for_all_photos} />
  </Page>
)
